module.exports = __webpack_public_path__ + "media/images/front/user/h1_mypage-ec25a8025e8ba0bdcb05d8120be46b89.svg";